export const formatVariance = (value: number | null | undefined | string): string => {
    if (value === null || value === undefined || value === '' || isNaN(Number(value))) {
        return '';
    }

    const numValue = Number(value);
    const absValue = Math.abs(numValue);
    const numStr = parseInt(absValue.toString()).toString();
    let formattedNum: string;

    if (numStr.length > 3) {
        // Format number with commas every 3 digits from right (US format)
        formattedNum = numStr.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    } else {
        formattedNum = numStr;
    }

    const formattedValue = `$${formattedNum}.${absValue.toFixed(2).split('.')[1]}`;

    if (numValue > 0) {
        return `+${formattedValue}`;
    } else if (numValue < 0) {
        return `-${formattedValue}`;
    } else {
        return formattedValue; // For zero values
    }
}; 